/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: any; output: any };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any };
};

export type AgGridParamsInput = {
  endRow: Scalars["Int"]["input"];
  filterModel: Scalars["JSON"]["input"];
  groupKeys: Array<Scalars["String"]["input"]>;
  queryId: Scalars["String"]["input"];
  rowGroupCols: Scalars["JSON"]["input"];
  sortModel: Scalars["JSON"]["input"];
  startRow: Scalars["Int"]["input"];
  valueCols: Scalars["JSON"]["input"];
};

export type AgGridQueryResponse = {
  data: Scalars["JSON"]["output"];
  hasNext: Scalars["Boolean"]["output"];
};

export type AvailabilitySlotDto = {
  endDateUtc: Scalars["String"]["output"];
  slotId: Scalars["String"]["output"];
  slotTimezone: Scalars["String"]["output"];
  startDateUtc: Scalars["String"]["output"];
};

export type AvailableWeekDayForGroup = {
  availableWeekDays: Array<WeekDayEnum>;
};

export type BookSlotClassRoomInput = {
  id: Scalars["String"]["input"];
};

export type BookSlotInput = {
  classRoom?: InputMaybe<BookSlotClassRoomInput>;
  endDateUtc: Scalars["String"]["input"];
  slotId: Scalars["String"]["input"];
  startDateUtc: Scalars["String"]["input"];
  timezone: Scalars["String"]["input"];
  topicId: Scalars["String"]["input"];
};

export type BookableSlot = {
  capacity: Scalars["Int"]["output"];
  classRoom?: Maybe<BookableSlotClassRoom>;
  endDateUtc: Scalars["String"]["output"];
  hasEnoughRemainingLessons: Scalars["Boolean"]["output"];
  participantsCount: Scalars["Int"]["output"];
  slotId: Scalars["ID"]["output"];
  slotLevel: SpeakingClassLevel;
  slotTimezone: Scalars["String"]["output"];
  slotType: ClassRoomType;
  startDateUtc: Scalars["String"]["output"];
  topic: Topic;
  userIsAParticipant: Scalars["Boolean"]["output"];
};

export type BookableSlotClassRoom = {
  canBeLeaved: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  meetingUri: Scalars["String"]["output"];
};

export type BulkClassRoomCreationIntent = {
  createdAt: Scalars["DateTimeISO"]["output"];
  id: Scalars["String"]["output"];
  maxClassRoomNumber?: Maybe<Scalars["Int"]["output"]>;
  numberOfWeeks?: Maybe<Scalars["Int"]["output"]>;
  startDate?: Maybe<Scalars["DateTimeISO"]["output"]>;
  studentId?: Maybe<Scalars["String"]["output"]>;
  teacherId?: Maybe<Scalars["String"]["output"]>;
  user1on1ClassroomPlanToBeRedeemedId?: Maybe<Scalars["String"]["output"]>;
  weekSlots?: Maybe<Array<WeekSlot>>;
};

export type BulkClassRoomCreationRequestGraphqlDto = {
  createdAt: Scalars["DateTimeISO"]["output"];
  id: Scalars["String"]["output"];
  status: BulkClassRoomCreationRequestStatus;
  teacher: BulkClassRoomCreationRequestTeacherGraphqlDto;
  totalClassRoomsToCreate: Scalars["Float"]["output"];
  updatedAt?: Maybe<Scalars["DateTimeISO"]["output"]>;
  user: BulkClassRoomCreationRequestUserGraphqlDto;
};

export enum BulkClassRoomCreationRequestStatus {
  Completed = "Completed",
  Creating = "Creating",
}

export type BulkClassRoomCreationRequestTeacherGraphqlDto = {
  familyName: Scalars["String"]["output"];
  givenName: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
};

export type BulkClassRoomCreationRequestUserGraphqlDto = {
  familyName: Scalars["String"]["output"];
  givenName: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
};

export enum CacheControlScope {
  Private = "PRIVATE",
  Public = "PUBLIC",
}

export type CalculateBulkClassRoomCreationSlotsInput = {
  maxClassRoomNumber?: InputMaybe<Scalars["Int"]["input"]>;
  numberOfWeeks: Scalars["Int"]["input"];
  startDate: Scalars["DateTimeISO"]["input"];
  studentId?: InputMaybe<Scalars["String"]["input"]>;
  teacherId: Scalars["String"]["input"];
  timezone?: InputMaybe<Scalars["String"]["input"]>;
  weekSlots: Array<WeekSlotInput>;
};

export type CalculatedSlot = {
  endDateUtc: Scalars["DateTimeISO"]["output"];
  startDateUtc: Scalars["DateTimeISO"]["output"];
  teacherConflictingClass?: Maybe<ClassRoom>;
  userConflictingClass?: Maybe<ClassRoom>;
};

export type ClassRoom = {
  capacity: Scalars["Int"]["output"];
  classRoomTimezone: Scalars["String"]["output"];
  endedAtUtc: Scalars["String"]["output"];
  feedbackReportUrl: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  meetingUrl: Scalars["String"]["output"];
  participants: Array<ClassRoomParticipant>;
  speakingLevel: SpeakingClassLevel;
  startedAtUtc: Scalars["String"]["output"];
  topic: Topic;
  userGroup: UserGroup;
  userGroupId: Scalars["String"]["output"];
};

export type ClassRoomListItem = {
  capacity: Scalars["Float"]["output"];
  classRoomTimezone: Scalars["String"]["output"];
  completedFeedbacksCount: Scalars["Int"]["output"];
  endedAtUtc: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  meetingUri: Scalars["String"]["output"];
  participantsCount: Scalars["Float"]["output"];
  speakingLevel: SpeakingClassLevel;
  startedAtUtc: Scalars["String"]["output"];
  teacher: ClassRoomTeacher;
  topic: Topic;
  type: ClassRoomType;
};

export type ClassRoomParticipant = {
  executedClassRoomCount: Scalars["Int"]["output"];
  familyName: Scalars["String"]["output"];
  givenName: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  speakingLevel: SpeakingClassLevel;
};

export type ClassRoomReviewDto = {
  classRoom: ClassRoomWithoutParticipantDto;
  classRoomId: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  reviewNotes: Scalars["String"]["output"];
  reviewedAtUtc: Scalars["String"]["output"];
  teacherId: Scalars["String"]["output"];
  userId: Scalars["String"]["output"];
};

export type ClassRoomTeacher = {
  email: Scalars["String"]["output"];
  familyName: Scalars["String"]["output"];
  givenName: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  phone?: Maybe<PhoneNumber>;
};

/** The class room type such as speaking class or exam */
export enum ClassRoomType {
  Exam = "Exam",
  SpeakingClass = "SpeakingClass",
}

export type ClassRoomV2 = {
  canBeLeaved: Scalars["Boolean"]["output"];
  capacity: Scalars["Float"]["output"];
  classRoomTimezone: Scalars["String"]["output"];
  endedAtUtc: Scalars["String"]["output"];
  feedbackReportUri: Scalars["String"]["output"];
  feedbackUri: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  meetingUri: Scalars["String"]["output"];
  participantsCount: Scalars["Float"]["output"];
  progressCheckTopic?: Maybe<ProgressCheckTopic>;
  speakingLevel: SpeakingClassLevel;
  startedAtUtc: Scalars["String"]["output"];
  teacher: Franchisee;
  teacherId: Scalars["String"]["output"];
  topic: Topic;
  type: ClassRoomType;
  userGroupId: Scalars["String"]["output"];
};

export type ClassRoomWithoutParticipantDto = {
  canBeLeaved: Scalars["Boolean"]["output"];
  capacity: Scalars["Float"]["output"];
  classRoomTimezone: Scalars["String"]["output"];
  endedAtUtc: Scalars["String"]["output"];
  feedbackReportUrl: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  is1on1?: Maybe<Scalars["Boolean"]["output"]>;
  meetingUri: Scalars["String"]["output"];
  participantsCount: Scalars["Float"]["output"];
  speakingLevel: SpeakingClassLevel;
  startedAtUtc: Scalars["String"]["output"];
  topic: Topic;
  type: ClassRoomType;
  userGroup: UserGroup;
  userGroupId: Scalars["String"]["output"];
};

export type CompleteClassRoom = {
  capacity: Scalars["Int"]["output"];
  conferenceUri: Scalars["String"]["output"];
  endedAtUtc: Scalars["String"]["output"];
  feedbackReportUrl: Scalars["String"]["output"];
  feedbackUrl: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  meetingUrl: Scalars["String"]["output"];
  participants: Array<CompleteClassRoomParticipant>;
  speakingLevel: SpeakingClassLevel;
  startedAtUtc: Scalars["String"]["output"];
  teacher: ClassRoomTeacher;
  topic: Topic;
};

export type CompleteClassRoomParticipant = {
  email: Scalars["String"]["output"];
  familyName: Scalars["String"]["output"];
  givenName: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
};

export type CreateBulk1on1ClassRoomsResultGraphqlDto = {
  planId: Scalars["String"]["output"];
  requestId: Scalars["String"]["output"];
};

export type CreateBulkClassRoomCreationIntentInput = {
  maxClassRoomNumber?: InputMaybe<Scalars["Int"]["input"]>;
  numberOfWeeks: Scalars["Int"]["input"];
  startDate: Scalars["DateTimeISO"]["input"];
  studentId?: InputMaybe<Scalars["String"]["input"]>;
  teacherId: Scalars["String"]["input"];
  user1on1ClassroomPlanToBeRedeemedId?: InputMaybe<Scalars["String"]["input"]>;
  weekSlots: Array<WeekSlotInput>;
};

export type CreateOneHourAvailabilitySlotInput = {
  endDateTime?: InputMaybe<Scalars["String"]["input"]>;
  startDateTime: Scalars["String"]["input"];
  timezone?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateRecurringAvailabilitySlotInput = {
  daysOfWeek: RepetitionDaysOfWeekInput;
  endDateTime: Scalars["String"]["input"];
  interval: Scalars["Float"]["input"];
  repeatUntil?: InputMaybe<Scalars["String"]["input"]>;
  startDateTime: Scalars["String"]["input"];
  timezone?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateUser1on1ClassroomPlanToBeRedeemedGraphqlInput = {
  totalNumberOfLessons: Scalars["Int"]["input"];
  userId: Scalars["String"]["input"];
};

export type FailedSubstitutionGraphqlDto = {
  classRoomId: Scalars["String"]["output"];
  endDateUtc: Scalars["DateTimeISO"]["output"];
  reason: Scalars["String"]["output"];
  startDateUtc: Scalars["DateTimeISO"]["output"];
  teacher?: Maybe<SwappedTeacherInfo>;
};

export type Franchisee = {
  authId: Scalars["String"]["output"];
  email: Scalars["String"]["output"];
  familyName: Scalars["String"]["output"];
  givenName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  lesson1on1?: Maybe<Scalars["Boolean"]["output"]>;
  phoneNumber?: Maybe<PhoneNumber>;
  shiftBaseId: Scalars["String"]["output"];
  userGroupIds: Array<Scalars["String"]["output"]>;
};

export type FrozenWeekDto = {
  endOfWeekUtc: Scalars["String"]["output"];
  startOfWeekUtc: Scalars["String"]["output"];
};

export type FrozenWeekInput = {
  endOfWeekDate: Scalars["String"]["input"];
  startOfWeekDate: Scalars["String"]["input"];
};

export type GetFreezableWeeksResponse = {
  remainingWeeksToFreeze: Array<RemainingWeeksToFreeze>;
  weeks: Array<WeekWithPlan>;
};

export type GetMyRemainingLessonResponse = {
  cancellationsUsed: Scalars["Int"]["output"];
  maxCancellations?: Maybe<Scalars["Int"]["output"]>;
  planEndDate?: Maybe<Scalars["String"]["output"]>;
  remainingLessons: Scalars["Int"]["output"];
  totalAvailableLessons: Scalars["Int"]["output"];
};

export type GetProgressCheckAvailabilityGraphqlResponse = {
  hasAtLeastOnProgressCheckBookable: Scalars["Boolean"]["output"];
  slots: Array<BookableSlot>;
};

export type GetProgressCheckUserListResponse = {
  participants: Array<ProgressCheckUserDto>;
  progressCheck: ClassRoomWithoutParticipantDto;
};

export type GetSpeakingClassAvailabilityResponse = {
  slots: Array<BookableSlot>;
};

export type GetUserClassRoomCountResponse = {
  totalClassRoomCount: Scalars["Int"]["output"];
};

export type GetUserRemainingLessonCountByWeekResponse = {
  hasUnlimitedLessonsPerWeek: Scalars["Boolean"]["output"];
  remainingLessonCount: Scalars["Int"]["output"];
  totalLessonCount: Scalars["Int"]["output"];
};

export type GiveProgressCheckFeedbackInput = {
  accuracy: Scalars["Int"]["input"];
  comprehension: Scalars["Int"]["input"];
  fluency: Scalars["Int"]["input"];
  noShow?: InputMaybe<Scalars["Boolean"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  passed: Scalars["Boolean"]["input"];
  progressCheckId: Scalars["String"]["input"];
  recommendation: Array<ProgressCheckRecommendation>;
  userId: Scalars["String"]["input"];
  vocabularyRange: Scalars["Int"]["input"];
};

export type HasUnlockedProgressCheckResponse = {
  hasUnlockedProgressCheck: Scalars["Boolean"]["output"];
  lessonCompletedToUnlockProgressCheck: Scalars["Int"]["output"];
  totalLessonNeededToUnlockProgressCheck: Scalars["Int"]["output"];
};

export type LevelChangeSuggestionDto = {
  id: Scalars["String"]["output"];
  suggestedLevels: Array<SpeakingClassLevel>;
  user: User;
  userId: Scalars["String"]["output"];
};

export type ListClassRoomDateInput = {
  fromDate: Scalars["String"]["input"];
  timezone: Scalars["String"]["input"];
  toDate: Scalars["String"]["input"];
};

export type ListClassRoomResponse = {
  classRooms: Array<ClassRoomListItem>;
  hasNextPage: Scalars["Boolean"]["output"];
  hasPrevPage: Scalars["Boolean"]["output"];
  nextPageToken?: Maybe<Scalars["String"]["output"]>;
  prevPageToken?: Maybe<Scalars["String"]["output"]>;
};

export type ListUserResponse = {
  hasNextPage: Scalars["Boolean"]["output"];
  hasPrevPage: Scalars["Boolean"]["output"];
  nextPageToken?: Maybe<Scalars["String"]["output"]>;
  prevPageToken?: Maybe<Scalars["String"]["output"]>;
  users: Array<User>;
};

export type Mutation = {
  addFrozenWeek: Scalars["Boolean"]["output"];
  addFrozenWeekToUser: Scalars["Boolean"]["output"];
  addParticipantsToClassByEmail: ClassRoom;
  bookProgressCheck: Scalars["Boolean"]["output"];
  bookSpeakingClass: Scalars["Boolean"]["output"];
  createBulk1on1ClassRooms: CreateBulk1on1ClassRoomsResultGraphqlDto;
  createBulkClassRoomCreationIntent: BulkClassRoomCreationIntent;
  createClassRoom: ClassRoom;
  createClassRoomPlan: UserClassRoomPlan;
  createFranchisee: Franchisee;
  createOneHourAvailabilitySlot: TeacherAvailabilitySlot;
  createProgressCheckPdf: ProgressCheckPdf;
  createRecurringAvailabilitySlot: Array<TeacherAvailabilitySlot>;
  createSeedUsers: Array<User>;
  createTopic: Topic;
  createUser: User;
  createUser1on1ClassroomPlanToBeRedeemed: User1on1ClassroomPlanToBeRedeemedGraphqlDto;
  createUserGroup: UserGroup;
  deleteAvailabilitySlot: Scalars["Boolean"]["output"];
  deleteClassRoom: Scalars["Boolean"]["output"];
  deleteClassRoomPlan: Scalars["Boolean"]["output"];
  deleteLessonFeedback: Scalars["Boolean"]["output"];
  deleteMe: Scalars["Boolean"]["output"];
  deleteSequenceAvailabilitySlots: Scalars["Boolean"]["output"];
  deleteTeacher: Scalars["Boolean"]["output"];
  editTopic: Topic;
  enrollUserToAllPaidContent: Scalars["Boolean"]["output"];
  giveProgressCheckFeedback: Scalars["Boolean"]["output"];
  leaveClassRoom: ClassRoomWithoutParticipantDto;
  leaveClassRoomReview: ClassRoomReviewDto;
  logicallyDeleteTopic: Scalars["Boolean"]["output"];
  removeAvailabilitySlot: Scalars["Boolean"]["output"];
  removeFrozenWeek: Scalars["Boolean"]["output"];
  removeFrozenWeekForUser: Scalars["Boolean"]["output"];
  removeParticipantFromClassRoom: RemoveParticipantFromClassRoomResponse;
  requestClassRoomDeletion: Scalars["Boolean"]["output"];
  resolveLevelSuggestion: Scalars["Boolean"]["output"];
  sendResetPasswordEmail: Scalars["Boolean"]["output"];
  suspendTeacherClassRoomAssignmentUntil: Scalars["Boolean"]["output"];
  swapTeacher: Scalars["Boolean"]["output"];
  try1on1TeacherSubstitution: TeacherSubstitutionResultGraphqlDto;
  updateBulkClassRoomCreationIntent: BulkClassRoomCreationIntent;
  updateLastLogin: Scalars["Boolean"]["output"];
  updateMe: User;
  updateTeacher: Franchisee;
  updateUser: User;
  updateUserClassRoomPlan: UserClassRoomPlan;
  updateUserLevelToNext: User;
  upsertLessonFeedback: Scalars["Boolean"]["output"];
  upsertProgressCheckPdf: Scalars["Boolean"]["output"];
};

export type MutationAddFrozenWeekArgs = {
  week: FrozenWeekInput;
};

export type MutationAddFrozenWeekToUserArgs = {
  userId: Scalars["String"]["input"];
  week: FrozenWeekInput;
};

export type MutationAddParticipantsToClassByEmailArgs = {
  classRoomId: Scalars["String"]["input"];
  userEmails: Array<Scalars["String"]["input"]>;
};

export type MutationBookProgressCheckArgs = {
  bookSlotInput: BookSlotInput;
};

export type MutationBookSpeakingClassArgs = {
  bookSlotInput: BookSlotInput;
};

export type MutationCreateBulk1on1ClassRoomsArgs = {
  intentId: Scalars["String"]["input"];
};

export type MutationCreateBulkClassRoomCreationIntentArgs = {
  input: CreateBulkClassRoomCreationIntentInput;
};

export type MutationCreateClassRoomArgs = {
  capacity: Scalars["Int"]["input"];
  classRoomType: ClassRoomType;
  participantIds: Array<Scalars["String"]["input"]>;
  speakingLevel: SpeakingClassLevel;
  startUtc: Scalars["String"]["input"];
  teacherId: Scalars["String"]["input"];
  topicId: Scalars["String"]["input"];
};

export type MutationCreateClassRoomPlanArgs = {
  endedAtWeekUtc: Scalars["String"]["input"];
  lessonsPerWeek: Scalars["Int"]["input"];
  planToRecoverId?: InputMaybe<Scalars["String"]["input"]>;
  startedAtWeekUtc: Scalars["String"]["input"];
  unlimitedLessonPerWeek?: InputMaybe<UnlimitedLessonPerWeekEnabledInput>;
  userId: Scalars["String"]["input"];
  warrantyConfig?: InputMaybe<UserClassRoomPlanWarrantyConfigInputDto>;
};

export type MutationCreateFranchiseeArgs = {
  email: Scalars["String"]["input"];
  familyName: Scalars["String"]["input"];
  givenName: Scalars["String"]["input"];
  lesson1on1?: InputMaybe<Scalars["Boolean"]["input"]>;
  phoneNumber: PhoneNumberInput;
  userGroupIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type MutationCreateOneHourAvailabilitySlotArgs = {
  input: CreateOneHourAvailabilitySlotInput;
};

export type MutationCreateProgressCheckPdfArgs = {
  level: SpeakingClassLevel;
  pdfUrl: Scalars["String"]["input"];
  userGroupId: Scalars["String"]["input"];
};

export type MutationCreateRecurringAvailabilitySlotArgs = {
  input: CreateRecurringAvailabilitySlotInput;
};

export type MutationCreateSeedUsersArgs = {
  count: Scalars["Float"]["input"];
  speakingLevel: SpeakingLevel;
};

export type MutationCreateTopicArgs = {
  level: SpeakingClassLevel;
  nameIt: Scalars["String"]["input"];
  pdfUrl: Scalars["String"]["input"];
  userGroupIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type MutationCreateUserArgs = {
  activateAccount?: InputMaybe<Scalars["Boolean"]["input"]>;
  email: Scalars["String"]["input"];
  familyName?: InputMaybe<Scalars["String"]["input"]>;
  givenName?: InputMaybe<Scalars["String"]["input"]>;
  hideBookProgressCheckSection?: InputMaybe<Scalars["Boolean"]["input"]>;
  hideBookSpeakingClassSection?: InputMaybe<Scalars["Boolean"]["input"]>;
  speakingLevel: SpeakingLevel;
  userGroupId?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateUser1on1ClassroomPlanToBeRedeemedArgs = {
  input: CreateUser1on1ClassroomPlanToBeRedeemedGraphqlInput;
};

export type MutationCreateUserGroupArgs = {
  availability?: InputMaybe<Array<UserGroupAvailabilityInput>>;
  name: Scalars["String"]["input"];
  thinkificBundleId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationDeleteAvailabilitySlotArgs = {
  occurrenceId: Scalars["String"]["input"];
};

export type MutationDeleteClassRoomArgs = {
  classRoomId: Scalars["String"]["input"];
};

export type MutationDeleteClassRoomPlanArgs = {
  planId: Scalars["String"]["input"];
};

export type MutationDeleteLessonFeedbackArgs = {
  lessonFeedbackId: Scalars["String"]["input"];
};

export type MutationDeleteSequenceAvailabilitySlotsArgs = {
  occurrenceId: Scalars["String"]["input"];
};

export type MutationDeleteTeacherArgs = {
  teacherId: Scalars["String"]["input"];
};

export type MutationEditTopicArgs = {
  id: Scalars["String"]["input"];
  nameIt?: InputMaybe<Scalars["String"]["input"]>;
  pdfUrl?: InputMaybe<Scalars["String"]["input"]>;
  userGroupIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type MutationEnrollUserToAllPaidContentArgs = {
  userId: Scalars["String"]["input"];
};

export type MutationGiveProgressCheckFeedbackArgs = {
  input: Array<GiveProgressCheckFeedbackInput>;
};

export type MutationLeaveClassRoomArgs = {
  classRoomId: Scalars["String"]["input"];
};

export type MutationLeaveClassRoomReviewArgs = {
  classRoomId: Scalars["String"]["input"];
  generalLessonScore: Scalars["Int"]["input"];
  reviewNotes: Scalars["String"]["input"];
  teacherClearanceScore: Scalars["Int"]["input"];
  teacherComfortableScore: Scalars["Int"]["input"];
  teacherInvolvementScore: Scalars["Int"]["input"];
  topicDifficultyScore: Scalars["Int"]["input"];
  topicUsefulnessScore: Scalars["Int"]["input"];
};

export type MutationLogicallyDeleteTopicArgs = {
  id: Scalars["String"]["input"];
};

export type MutationRemoveAvailabilitySlotArgs = {
  slotId: Scalars["String"]["input"];
};

export type MutationRemoveFrozenWeekArgs = {
  week: FrozenWeekInput;
};

export type MutationRemoveFrozenWeekForUserArgs = {
  userId: Scalars["String"]["input"];
  week: FrozenWeekInput;
};

export type MutationRemoveParticipantFromClassRoomArgs = {
  classRoomId: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
};

export type MutationRequestClassRoomDeletionArgs = {
  classId: Scalars["String"]["input"];
};

export type MutationResolveLevelSuggestionArgs = {
  suggestionId: Scalars["String"]["input"];
};

export type MutationSuspendTeacherClassRoomAssignmentUntilArgs = {
  suspendUntilUtc: Scalars["String"]["input"];
  teacherId: Scalars["String"]["input"];
};

export type MutationSwapTeacherArgs = {
  classRoomId: Scalars["String"]["input"];
  doNotMakeOldTeacherAvailableAgain: Scalars["Boolean"]["input"];
  teacherToAddId: Scalars["String"]["input"];
};

export type MutationTry1on1TeacherSubstitutionArgs = {
  intentId: Scalars["String"]["input"];
  timezone?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateBulkClassRoomCreationIntentArgs = {
  input: UpdateBulkClassRoomCreationIntentInput;
};

export type MutationUpdateMeArgs = {
  familyName?: InputMaybe<Scalars["String"]["input"]>;
  givenName?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateTeacherArgs = {
  familyName?: InputMaybe<Scalars["String"]["input"]>;
  givenName?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  lesson1on1?: InputMaybe<Scalars["Boolean"]["input"]>;
  phoneNumber?: InputMaybe<PhoneNumberInput>;
  userGroupIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type MutationUpdateUserArgs = {
  activateAccount?: InputMaybe<Scalars["Boolean"]["input"]>;
  familyName?: InputMaybe<Scalars["String"]["input"]>;
  givenName?: InputMaybe<Scalars["String"]["input"]>;
  hideBookProgressCheckSection?: InputMaybe<Scalars["Boolean"]["input"]>;
  hideBookSpeakingClassSection?: InputMaybe<Scalars["Boolean"]["input"]>;
  speakingLevel?: InputMaybe<SpeakingLevel>;
  userGroupId?: InputMaybe<Scalars["String"]["input"]>;
  userId: Scalars["String"]["input"];
};

export type MutationUpdateUserClassRoomPlanArgs = {
  planId: Scalars["String"]["input"];
  planToRecoverId?: InputMaybe<Scalars["String"]["input"]>;
  unlimitedLessonPerWeek?: InputMaybe<UnlimitedLessonPerWeekEnabledInput>;
  warrantyConfig?: InputMaybe<UserClassRoomPlanWarrantyConfigInputDto>;
};

export type MutationUpdateUserLevelToNextArgs = {
  userId: Scalars["String"]["input"];
};

export type MutationUpsertLessonFeedbackArgs = {
  classRoomId: Scalars["String"]["input"];
  lessonFeedback: Array<UpsertUserLessonFeedbackInput>;
};

export type MutationUpsertProgressCheckPdfArgs = {
  level: SpeakingClassLevel;
  pdfUrl: Scalars["String"]["input"];
  userGroupId: Scalars["String"]["input"];
};

export type PhoneNumber = {
  countryCode: Scalars["String"]["output"];
  number: Scalars["String"]["output"];
};

export type PhoneNumberInput = {
  countryCode: Scalars["String"]["input"];
  number: Scalars["String"]["input"];
};

export type ProgressCheckPdf = {
  level: SpeakingClassLevel;
  pdfUrl: Scalars["String"]["output"];
  userGroup: UserGroup;
  userGroupId: Scalars["String"]["output"];
};

export enum ProgressCheckRecommendation {
  MoreAccuracy = "MoreAccuracy",
  MoreFluency = "MoreFluency",
  MoreImmersion = "MoreImmersion",
  MoreVocabulary = "MoreVocabulary",
}

export type ProgressCheckResultDto = {
  accuracy: Scalars["Int"]["output"];
  comprehension: Scalars["Int"]["output"];
  fluency: Scalars["Int"]["output"];
  noShow: Scalars["Boolean"]["output"];
  notes?: Maybe<Scalars["String"]["output"]>;
  passed: Scalars["Boolean"]["output"];
  progressCheckId: Scalars["String"]["output"];
  progressCheckLevel: SpeakingClassLevel;
  progressCheckStartedAtUtc: Scalars["String"]["output"];
  recommendation: Array<ProgressCheckRecommendation>;
  teacher: ClassRoomTeacher;
  teacherId: Scalars["String"]["output"];
  toLevel?: Maybe<SpeakingClassLevel>;
  userId: Scalars["String"]["output"];
  vocabularyRange: Scalars["Int"]["output"];
};

export type ProgressCheckTopic = {
  level: SpeakingClassLevel;
  pdfUri: Scalars["String"]["output"];
};

export type ProgressCheckUserDto = {
  alreadyGivenFeedback: Scalars["Boolean"]["output"];
  canImproveSpeakingLevel: Scalars["Boolean"]["output"];
  familyName: Scalars["String"]["output"];
  givenName: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  shouldPassPcDueToStarter: Scalars["Boolean"]["output"];
};

export type Query = {
  adminGetClassRoomById: CompleteClassRoom;
  calculateBulkClassRoomCreationSlots: Array<CalculatedSlot>;
  calculatePlanGivenSlotByParams: Scalars["Int"]["output"];
  getAllActiveUsersByIds: Array<Maybe<User>>;
  getAllBulkClassRoomCreationRequests: Array<BulkClassRoomCreationRequestGraphqlDto>;
  getAllByShiftBaseUserIds: Array<Franchisee>;
  getAllFranchisees: Array<Franchisee>;
  getAllProgressCheckPdfs: Array<ProgressCheckPdf>;
  getAllTeacherByIds: Array<Franchisee>;
  getAllTopics: Array<Topic>;
  getAllUserGroups: Array<UserGroup>;
  getAllUsersByIds: Array<Maybe<User>>;
  getAvailabilityByTeacherForWeek: Array<AvailabilitySlotDto>;
  getAvailabilityForProgressCheck: GetProgressCheckAvailabilityGraphqlResponse;
  getAvailabilityForSpeakingClass: GetSpeakingClassAvailabilityResponse;
  getAvailableTeachersInHour: Array<ClassRoomTeacher>;
  getBulkClassRoomCreationIntent: BulkClassRoomCreationIntent;
  getByAuthId: User;
  getClassRoomById: ClassRoom;
  getClassRoomByIdV2: ClassRoomV2;
  getClassRoomPlanByIdAndUserId: UserClassRoomPlan;
  getClassRoomsByTeacherAndDateRange: Array<ClassRoomV2>;
  getCurrentLoggedInTeacherAvailability: Array<TeacherAvailabilitySlot>;
  getFirstPassedProgressCheckResultByUserIds: Array<ProgressCheckResultDto>;
  getFranchiseeById: Franchisee;
  getFreezableWeeks: GetFreezableWeeksResponse;
  getFreezableWeeksByUser: GetFreezableWeeksResponse;
  getFrozenWeeksByUser: Array<FrozenWeekDto>;
  getIdsOfUsersEligibleForRLCWarranty: Array<Scalars["String"]["output"]>;
  getLessonFeedbackReportByUser: UserLessonFeedbackReport;
  getLoggedTeacher: Franchisee;
  getMinUsedTopicsInLevelAmongParticipants: Array<Topic>;
  getMyFrozenWeeks: Array<FrozenWeekDto>;
  getMyRemaining1on1Lessons?: Maybe<GetMyRemainingLessonResponse>;
  getMyRemainingLessons: GetMyRemainingLessonResponse;
  getMyWorkedHoursOfAMonth: Array<WorkedHour>;
  getProgressCheckResultByUserId: Array<ProgressCheckResultDto>;
  getProgressCheckUserList: GetProgressCheckUserListResponse;
  getTeacherByAuthId: Franchisee;
  getTeacherClassRooms: Array<ClassRoomWithoutParticipantDto>;
  getTeacherFutureClassRooms: Array<ClassRoomV2>;
  getTeachersWithLimitedAvailabilitySlots: Array<Franchisee>;
  getTopicById: Topic;
  getUser1on1ClassroomPlans: Array<User1on1ClassroomPlanGraphqlDto>;
  getUser1on1ClassroomPlansToBeRedeemed: Array<User1on1ClassroomPlanToBeRedeemedGraphqlDto>;
  getUserByEmailEvenIfDeleted: User;
  getUserById: User;
  getUserClassRoomCount: GetUserClassRoomCountResponse;
  getUserClassRoomPlans: Array<UserClassRoomPlan>;
  getUserClassRoomsBetweenDates: Array<ClassRoomWithoutParticipantDto>;
  getUserGroupAvailableDays: AvailableWeekDayForGroup;
  getUserRemainingLessonByWeek: GetUserRemainingLessonCountByWeekResponse;
  getUserRemainingLessons: Scalars["Int"]["output"];
  getUsersEligibleForWarranty: Array<User>;
  hasSpeakingEnabled: Scalars["Boolean"]["output"];
  hasUnlockedProgressCheck: HasUnlockedProgressCheckResponse;
  isActiveUser: Scalars["Boolean"]["output"];
  isActiveUserForAdminById: Scalars["Boolean"]["output"];
  isFrozenWeek: Scalars["Boolean"]["output"];
  listAllUsers: ListUserResponse;
  listClassRooms: ListClassRoomResponse;
  listNotResolvedLevelChangeSuggestions: Array<LevelChangeSuggestionDto>;
  me?: Maybe<User>;
  myWorkedHoursByMonth: Array<WorkedHoursByMonthItem>;
  safelyGetUserByEmail?: Maybe<User>;
  searchTeachersByEmail: Array<Franchisee>;
  speakingClassServiceAgGridQuery: AgGridQueryResponse;
  userActivePlansStatus: UserActivePlansStatus;
};

export type QueryAdminGetClassRoomByIdArgs = {
  classRoomId: Scalars["String"]["input"];
};

export type QueryCalculateBulkClassRoomCreationSlotsArgs = {
  input: CalculateBulkClassRoomCreationSlotsInput;
};

export type QueryCalculatePlanGivenSlotByParamsArgs = {
  endedAtWeekUtc: Scalars["String"]["input"];
  lessonsPerWeek: Scalars["Int"]["input"];
  startedAtWeekUtc: Scalars["String"]["input"];
  unlimitedLessonPerWeek?: InputMaybe<UnlimitedLessonPerWeekEnabledInput>;
};

export type QueryGetAllActiveUsersByIdsArgs = {
  userIds: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type QueryGetAllByShiftBaseUserIdsArgs = {
  shiftBaseUserIds: Array<Scalars["String"]["input"]>;
};

export type QueryGetAllTeacherByIdsArgs = {
  ids: Array<Scalars["String"]["input"]>;
};

export type QueryGetAllUsersByIdsArgs = {
  userIds: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type QueryGetAvailabilityByTeacherForWeekArgs = {
  fromDate: Scalars["String"]["input"];
  teacherId: Scalars["String"]["input"];
  timezone: Scalars["String"]["input"];
  toDate: Scalars["String"]["input"];
};

export type QueryGetAvailabilityForProgressCheckArgs = {
  clientTimezone: Scalars["String"]["input"];
  fromDate: Scalars["String"]["input"];
  toDate: Scalars["String"]["input"];
};

export type QueryGetAvailabilityForSpeakingClassArgs = {
  clientTimezone: Scalars["String"]["input"];
  fromDate: Scalars["String"]["input"];
  toDate: Scalars["String"]["input"];
};

export type QueryGetAvailableTeachersInHourArgs = {
  startUtc: Scalars["String"]["input"];
  timezone: Scalars["String"]["input"];
};

export type QueryGetBulkClassRoomCreationIntentArgs = {
  id: Scalars["String"]["input"];
};

export type QueryGetByAuthIdArgs = {
  authId: Scalars["String"]["input"];
};

export type QueryGetClassRoomByIdArgs = {
  classRoomId: Scalars["String"]["input"];
};

export type QueryGetClassRoomByIdV2Args = {
  classRoomId: Scalars["String"]["input"];
};

export type QueryGetClassRoomPlanByIdAndUserIdArgs = {
  planId: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
};

export type QueryGetClassRoomsByTeacherAndDateRangeArgs = {
  endUtc: Scalars["String"]["input"];
  startUtc: Scalars["String"]["input"];
};

export type QueryGetCurrentLoggedInTeacherAvailabilityArgs = {
  maxDateString: Scalars["String"]["input"];
  minDateString: Scalars["String"]["input"];
};

export type QueryGetFirstPassedProgressCheckResultByUserIdsArgs = {
  userIds: Array<Scalars["String"]["input"]>;
};

export type QueryGetFranchiseeByIdArgs = {
  id: Scalars["String"]["input"];
};

export type QueryGetFreezableWeeksByUserArgs = {
  userId: Scalars["String"]["input"];
};

export type QueryGetFrozenWeeksByUserArgs = {
  userId: Scalars["String"]["input"];
};

export type QueryGetIdsOfUsersEligibleForRlcWarrantyArgs = {
  plansEndAfter?: InputMaybe<Scalars["String"]["input"]>;
  plansEndBefore?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetLessonFeedbackReportByUserArgs = {
  userId: Scalars["String"]["input"];
};

export type QueryGetMinUsedTopicsInLevelAmongParticipantsArgs = {
  participantIds: Array<Scalars["String"]["input"]>;
  speakingLevel: SpeakingClassLevel;
};

export type QueryGetMyWorkedHoursOfAMonthArgs = {
  clientTimezone: Scalars["String"]["input"];
  monthStartDateTimeUtc: Scalars["String"]["input"];
};

export type QueryGetProgressCheckResultByUserIdArgs = {
  userId: Scalars["String"]["input"];
};

export type QueryGetProgressCheckUserListArgs = {
  progressCheckId: Scalars["String"]["input"];
};

export type QueryGetTeacherByAuthIdArgs = {
  authId: Scalars["String"]["input"];
};

export type QueryGetTeacherClassRoomsArgs = {
  fromDate: Scalars["String"]["input"];
  teacherId: Scalars["String"]["input"];
  timezone: Scalars["String"]["input"];
  toDate: Scalars["String"]["input"];
};

export type QueryGetTeacherFutureClassRoomsArgs = {
  teacherId: Scalars["String"]["input"];
};

export type QueryGetTopicByIdArgs = {
  id: Scalars["String"]["input"];
};

export type QueryGetUser1on1ClassroomPlansArgs = {
  userId: Scalars["String"]["input"];
};

export type QueryGetUser1on1ClassroomPlansToBeRedeemedArgs = {
  userId: Scalars["String"]["input"];
};

export type QueryGetUserByEmailEvenIfDeletedArgs = {
  email: Scalars["String"]["input"];
};

export type QueryGetUserByIdArgs = {
  userId: Scalars["String"]["input"];
};

export type QueryGetUserClassRoomPlansArgs = {
  userId: Scalars["String"]["input"];
};

export type QueryGetUserClassRoomsBetweenDatesArgs = {
  clientTimezone: Scalars["String"]["input"];
  fromDate: Scalars["String"]["input"];
  toDate: Scalars["String"]["input"];
};

export type QueryGetUserRemainingLessonByWeekArgs = {
  clientTimezone: Scalars["String"]["input"];
  dateUtc: Scalars["String"]["input"];
};

export type QueryGetUserRemainingLessonsArgs = {
  userId: Scalars["String"]["input"];
};

export type QueryGetUsersEligibleForWarrantyArgs = {
  plansEndAfter?: InputMaybe<Scalars["String"]["input"]>;
  plansEndBefore?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryIsActiveUserForAdminByIdArgs = {
  userId: Scalars["String"]["input"];
};

export type QueryIsFrozenWeekArgs = {
  week: FrozenWeekInput;
};

export type QueryListAllUsersArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  limit: Scalars["Int"]["input"];
  nextPageToken?: InputMaybe<Scalars["String"]["input"]>;
  prevPageToken?: InputMaybe<Scalars["String"]["input"]>;
  withSpeakingLevel?: InputMaybe<Array<InputMaybe<SpeakingLevel>>>;
};

export type QueryListClassRoomsArgs = {
  dateRange?: InputMaybe<ListClassRoomDateInput>;
  limit: Scalars["Int"]["input"];
  nextToken?: InputMaybe<Scalars["String"]["input"]>;
  prevToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryMyWorkedHoursByMonthArgs = {
  clientTimezone: Scalars["String"]["input"];
  endDateUtc: Scalars["String"]["input"];
  startDateUtc: Scalars["String"]["input"];
};

export type QuerySafelyGetUserByEmailArgs = {
  email: Scalars["String"]["input"];
};

export type QuerySearchTeachersByEmailArgs = {
  filter: Scalars["String"]["input"];
};

export type QuerySpeakingClassServiceAgGridQueryArgs = {
  params: AgGridParamsInput;
};

export type RemainingWeeksToFreeze = {
  planId: Scalars["String"]["output"];
  remainingCount: Scalars["Float"]["output"];
};

export type RemoveParticipantFromClassRoomResponse = {
  classRoom: ClassRoom;
  classRoomDeleted: Scalars["Boolean"]["output"];
};

export type RepetitionDaysOfWeekInput = {
  fr: Scalars["Boolean"]["input"];
  mo: Scalars["Boolean"]["input"];
  sa: Scalars["Boolean"]["input"];
  su: Scalars["Boolean"]["input"];
  th: Scalars["Boolean"]["input"];
  tu: Scalars["Boolean"]["input"];
  we: Scalars["Boolean"]["input"];
};

export enum SpeakingClassLevel {
  Explorers = "Explorers",
  Navigators = "Navigators",
  Pioneers = "Pioneers",
  Starters = "Starters",
  Voyagers = "Voyagers",
}

/** The user speaking level */
export enum SpeakingLevel {
  Explorers = "Explorers",
  Navigators = "Navigators",
  Pioneers = "Pioneers",
  Starters = "Starters",
  Unknown = "Unknown",
  Voyagers = "Voyagers",
}

export type SuccessfulSubstitutionGraphqlDto = {
  classRoomId: Scalars["String"]["output"];
  endDateUtc: Scalars["DateTimeISO"]["output"];
  newTeacher: SwappedTeacherInfo;
  originalTeacher: SwappedTeacherInfo;
  startDateUtc: Scalars["DateTimeISO"]["output"];
};

export type SwappedTeacherInfo = {
  email: Scalars["String"]["output"];
  familyName: Scalars["String"]["output"];
  givenName: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  lesson1on1: Scalars["Boolean"]["output"];
};

export type TeacherAvailabilitySlot = {
  endDateTime: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  recurring: Scalars["Boolean"]["output"];
  slotTimezone: Scalars["String"]["output"];
  startDateTime: Scalars["String"]["output"];
};

export type TeacherSubstitutionResultGraphqlDto = {
  failedSubstitutions: Array<FailedSubstitutionGraphqlDto>;
  successfulSubstitutions: Array<SuccessfulSubstitutionGraphqlDto>;
};

export type TimeInterval = {
  from: Scalars["Int"]["output"];
  to: Scalars["Int"]["output"];
};

export type TimeIntervalInput = {
  from: Scalars["Int"]["input"];
  to: Scalars["Int"]["input"];
};

export type Topic = {
  id: Scalars["String"]["output"];
  level: SpeakingClassLevel;
  name: Scalars["String"]["output"];
  pdfUrl: Scalars["String"]["output"];
  userGroupIds: Array<Scalars["String"]["output"]>;
  userGroups: Array<UserGroup>;
};

export type UnlimitedLessonPerWeekEnabledInput = {
  enabled: Scalars["Boolean"]["input"];
  totalLessons?: InputMaybe<Scalars["Float"]["input"]>;
};

export type UpdateBulkClassRoomCreationIntentInput = {
  id: Scalars["String"]["input"];
  maxClassRoomNumber?: InputMaybe<Scalars["Int"]["input"]>;
  numberOfWeeks?: InputMaybe<Scalars["Int"]["input"]>;
  startDate?: InputMaybe<Scalars["DateTimeISO"]["input"]>;
  studentId?: InputMaybe<Scalars["String"]["input"]>;
  teacherId?: InputMaybe<Scalars["String"]["input"]>;
  user1on1ClassroomPlanToBeRedeemedId?: InputMaybe<Scalars["String"]["input"]>;
  weekSlots?: InputMaybe<Array<WeekSlotInput>>;
};

export type UpsertUserLessonFeedbackInput = {
  differentSpeakingLevelSuggested?: InputMaybe<SpeakingClassLevel>;
  noShow: Scalars["Boolean"]["input"];
  notes: Scalars["String"]["input"];
  participationScore: Scalars["Int"]["input"];
  targetLanguageScore: Scalars["Int"]["input"];
  userId: Scalars["String"]["input"];
};

export type User = {
  authId: Scalars["String"]["output"];
  createdAt: Scalars["String"]["output"];
  email: Scalars["String"]["output"];
  familyName: Scalars["String"]["output"];
  firstPlanStartDate?: Maybe<Scalars["String"]["output"]>;
  givenName: Scalars["String"]["output"];
  hideBookProgressCheckSection: Scalars["Boolean"]["output"];
  hideBookSpeakingClassSection: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  lastPlanEndDate?: Maybe<Scalars["String"]["output"]>;
  lastSelfAssessmentLevel: SpeakingLevel;
  lessonFeedbacks: Array<UserLessonFeedbackDto>;
  partecipatedProgressCheckCount: Scalars["Int"]["output"];
  partecipatedSpeakingClassCount: Scalars["Int"]["output"];
  progressCheckResults: Array<ProgressCheckResultDto>;
  speakingLevel: SpeakingLevel;
  startingSpeakingLevel: SpeakingLevel;
  userGroup: UserGroup;
};

export type User1on1ClassroomPlanGraphqlDto = {
  createdAt: Scalars["DateTimeISO"]["output"];
  endDateUtc: Scalars["DateTimeISO"]["output"];
  id: Scalars["String"]["output"];
  lessonsPerWeek: Scalars["Float"]["output"];
  numberOfWeeks: Scalars["Float"]["output"];
  startDateUtc: Scalars["DateTimeISO"]["output"];
  userId: Scalars["String"]["output"];
};

export type User1on1ClassroomPlanToBeRedeemedGraphqlDto = {
  createdAt: Scalars["DateTimeISO"]["output"];
  createdPlanId?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  totalNumberOfLessons: Scalars["Float"]["output"];
  userId: Scalars["String"]["output"];
};

export type UserActivePlansStatus = {
  hasActive1on1Plan: Scalars["Boolean"]["output"];
  hasActiveGroupPlan: Scalars["Boolean"]["output"];
};

export type UserClassRoomPlan = {
  endedAtWeekUtc: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  lessonsPerWeek: Scalars["Float"]["output"];
  numberOfSlotIncluded: Scalars["Float"]["output"];
  planToRecoverId?: Maybe<Scalars["String"]["output"]>;
  startedAtWeekUtc: Scalars["String"]["output"];
  unlimitedLessonsPerWeekEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  userId: Scalars["String"]["output"];
  warrantyConfig?: Maybe<UserClassRoomPlanWarrantyConfigDto>;
};

export type UserClassRoomPlanWarrantyConfigDto = {
  enabled: Scalars["Boolean"]["output"];
  minAttendedLessons?: Maybe<Scalars["Int"]["output"]>;
};

export type UserClassRoomPlanWarrantyConfigInputDto = {
  enabled: Scalars["Boolean"]["input"];
  minAttendedLessons?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UserGroup = {
  availability?: Maybe<Array<UserGroupAvailability>>;
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  thinkificBundleId?: Maybe<Scalars["Int"]["output"]>;
};

export type UserGroupAvailability = {
  timeIntervalTimezone: Scalars["String"]["output"];
  timeIntervals: Array<TimeInterval>;
  weekDay: WeekDayEnum;
};

export type UserGroupAvailabilityInput = {
  timeIntervalTimezone: Scalars["String"]["input"];
  timeIntervals: Array<TimeIntervalInput>;
  weekDay: WeekDayEnum;
};

export type UserLessonFeedbackDto = {
  classRoomEndDateUtc: Scalars["String"]["output"];
  classRoomStartDateUtc: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  noShow: Scalars["Boolean"]["output"];
  notes: Scalars["String"]["output"];
  participation: Scalars["Int"]["output"];
  targetLanguage: Scalars["Int"]["output"];
  teacher: ClassRoomTeacher;
  teacherId: Scalars["String"]["output"];
};

export type UserLessonFeedbackNote = {
  classRoomStartDateUtc: Scalars["String"]["output"];
  classRoomTopicName: Scalars["String"]["output"];
  note: Scalars["String"]["output"];
};

export type UserLessonFeedbackReport = {
  avgParticipationScore: Scalars["Float"]["output"];
  avgTargetLanguageScore: Scalars["Float"]["output"];
  hasAtLeastOneFeedback: Scalars["Boolean"]["output"];
  notes: Array<UserLessonFeedbackNote>;
  userFamilyName: Scalars["String"]["output"];
  userGivenName: Scalars["String"]["output"];
  userId: Scalars["String"]["output"];
};

export enum WeekDayEnum {
  Friday = "Friday",
  Monday = "Monday",
  Saturday = "Saturday",
  Sunday = "Sunday",
  Thursday = "Thursday",
  Tuesday = "Tuesday",
  Wednesday = "Wednesday",
}

export type WeekSlot = {
  dayOfWeek: Scalars["Int"]["output"];
  endTime: Scalars["String"]["output"];
  startTime: Scalars["String"]["output"];
};

export type WeekSlotInput = {
  dayOfWeek: Scalars["Int"]["input"];
  endTime: Scalars["String"]["input"];
  startTime: Scalars["String"]["input"];
};

export type WeekWithPlan = {
  planId: Scalars["String"]["output"];
  week: FrozenWeekDto;
};

export type WorkedHour = {
  endDateUtc: Scalars["String"]["output"];
  hourlyWageInCents: Scalars["Float"]["output"];
  id: Scalars["String"]["output"];
  startDateUtc: Scalars["String"]["output"];
};

export type WorkedHoursByMonthItem = {
  endOfMonthDate: Scalars["String"]["output"];
  startOfMonthDate: Scalars["String"]["output"];
  totalTaxableAmountInCents: Scalars["Float"]["output"];
};

export type GetClassRoomByIdV2QueryVariables = Exact<{
  classRoomId: Scalars["String"]["input"];
}>;

export type GetClassRoomByIdV2Query = {
  getClassRoomByIdV2: {
    " $fragmentRefs"?: { ClassRoomV2Fragment: ClassRoomV2Fragment };
  };
};

export type LeaveClassRoomReviewMutationVariables = Exact<{
  classRoomId: Scalars["String"]["input"];
  reviewNotes: Scalars["String"]["input"];
  teacherClearanceScore: Scalars["Int"]["input"];
  teacherComfortableScore: Scalars["Int"]["input"];
  teacherInvolvementScore: Scalars["Int"]["input"];
  generalLessonScore: Scalars["Int"]["input"];
  topicDifficultyScore: Scalars["Int"]["input"];
  topicUsefulnessScore: Scalars["Int"]["input"];
}>;

export type LeaveClassRoomReviewMutation = {
  leaveClassRoomReview: { id: string };
};

export type BookableSlotFragmentFragment = {
  slotId: string;
  startDateUtc: string;
  endDateUtc: string;
  hasEnoughRemainingLessons: boolean;
  capacity: number;
  slotLevel: SpeakingClassLevel;
  participantsCount: number;
  slotType: ClassRoomType;
  userIsAParticipant: boolean;
  slotTimezone: string;
  topic: {
    name: string;
    id: string;
    level: SpeakingClassLevel;
    pdfUrl: string;
  };
  classRoom?: { id: string; meetingUri: string; canBeLeaved: boolean } | null;
} & { " $fragmentName"?: "BookableSlotFragmentFragment" };

export type ClassRoomFragmentFragment = {
  id: string;
  endedAtUtc: string;
  startedAtUtc: string;
  type: ClassRoomType;
  speakingLevel: SpeakingClassLevel;
  capacity: number;
  participantsCount: number;
  meetingUri: string;
  canBeLeaved: boolean;
  classRoomTimezone: string;
  is1on1?: boolean | null;
  topic: {
    name: string;
    id: string;
    level: SpeakingClassLevel;
    pdfUrl: string;
  };
} & { " $fragmentName"?: "ClassRoomFragmentFragment" };

export type ClassRoomV2Fragment = {
  id: string;
  endedAtUtc: string;
  startedAtUtc: string;
  type: ClassRoomType;
  speakingLevel: SpeakingClassLevel;
  capacity: number;
  participantsCount: number;
  meetingUri: string;
  canBeLeaved: boolean;
  classRoomTimezone: string;
  topic: {
    name: string;
    id: string;
    level: SpeakingClassLevel;
    pdfUrl: string;
  };
  teacher: { id: string; givenName: string; familyName: string };
} & { " $fragmentName"?: "ClassRoomV2Fragment" };

export type LeaveClassRoomMutationVariables = Exact<{
  classRoomId: Scalars["String"]["input"];
}>;

export type LeaveClassRoomMutation = {
  leaveClassRoom: {
    " $fragmentRefs"?: { ClassRoomFragmentFragment: ClassRoomFragmentFragment };
  };
};

export type GetUserClassRoomsBetweenDatesQueryVariables = Exact<{
  fromDate: Scalars["String"]["input"];
  toDate: Scalars["String"]["input"];
  clientTimezone: Scalars["String"]["input"];
}>;

export type GetUserClassRoomsBetweenDatesQuery = {
  getUserClassRoomsBetweenDates: Array<{
    " $fragmentRefs"?: { ClassRoomFragmentFragment: ClassRoomFragmentFragment };
  }>;
};

export type BookProgressCheckMutationVariables = Exact<{
  bookSlotInput: BookSlotInput;
}>;

export type BookProgressCheckMutation = { bookProgressCheck: boolean };

export type HasUnlockedProgressCheckQueryVariables = Exact<{
  [key: string]: never;
}>;

export type HasUnlockedProgressCheckQuery = {
  hasUnlockedProgressCheck: {
    lessonCompletedToUnlockProgressCheck: number;
    totalLessonNeededToUnlockProgressCheck: number;
    hasUnlockedProgressCheck: boolean;
  };
};

export type GetAvailabilityForProgressCheckQueryVariables = Exact<{
  clientTimezone: Scalars["String"]["input"];
  fromDate: Scalars["String"]["input"];
  toDate: Scalars["String"]["input"];
}>;

export type GetAvailabilityForProgressCheckQuery = {
  getAvailabilityForProgressCheck: {
    hasAtLeastOnProgressCheckBookable: boolean;
    slots: Array<{
      " $fragmentRefs"?: {
        BookableSlotFragmentFragment: BookableSlotFragmentFragment;
      };
    }>;
  };
};

export type BookSpeakingClassMutationVariables = Exact<{
  bookSlotInput: BookSlotInput;
}>;

export type BookSpeakingClassMutation = { bookSpeakingClass: boolean };

export type GetAvailabilityForSpeakingClassQueryVariables = Exact<{
  clientTimezone: Scalars["String"]["input"];
  fromDate: Scalars["String"]["input"];
  toDate: Scalars["String"]["input"];
}>;

export type GetAvailabilityForSpeakingClassQuery = {
  getAvailabilityForSpeakingClass: {
    slots: Array<{
      " $fragmentRefs"?: {
        BookableSlotFragmentFragment: BookableSlotFragmentFragment;
      };
    }>;
  };
};

export type HasSpeakingEnabledQueryVariables = Exact<{ [key: string]: never }>;

export type HasSpeakingEnabledQuery = { hasSpeakingEnabled: boolean };

export type IsActiveUserQueryVariables = Exact<{ [key: string]: never }>;

export type IsActiveUserQuery = { isActiveUser: boolean };

export type FrozenWeekFragment = {
  startOfWeekUtc: string;
  endOfWeekUtc: string;
} & { " $fragmentName"?: "FrozenWeekFragment" };

export type GetFreezableWeeksResponseFragment = {
  weeks: Array<{
    planId: string;
    week: { startOfWeekUtc: string; endOfWeekUtc: string };
  }>;
  remainingWeeksToFreeze: Array<{ planId: string; remainingCount: number }>;
} & { " $fragmentName"?: "GetFreezableWeeksResponseFragment" };

export type GetFreezableWeeksQueryVariables = Exact<{ [key: string]: never }>;

export type GetFreezableWeeksQuery = {
  getFreezableWeeks: {
    " $fragmentRefs"?: {
      GetFreezableWeeksResponseFragment: GetFreezableWeeksResponseFragment;
    };
  };
};

export type AddFrozenWeekMutationVariables = Exact<{
  week: FrozenWeekInput;
}>;

export type AddFrozenWeekMutation = { addFrozenWeek: boolean };

export type IsFrozenWeekQueryVariables = Exact<{
  week: FrozenWeekInput;
}>;

export type IsFrozenWeekQuery = { isFrozenWeek: boolean };

export type GetMyFrozenWeeksQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyFrozenWeeksQuery = {
  getMyFrozenWeeks: Array<{
    " $fragmentRefs"?: { FrozenWeekFragment: FrozenWeekFragment };
  }>;
};

export type RemoveFrozenWeekMutationVariables = Exact<{
  week: FrozenWeekInput;
}>;

export type RemoveFrozenWeekMutation = { removeFrozenWeek: boolean };

export type GetMyRemaining1on1LessonsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetMyRemaining1on1LessonsQuery = {
  getMyRemaining1on1Lessons?: {
    remainingLessons: number;
    totalAvailableLessons: number;
    planEndDate?: string | null;
    cancellationsUsed: number;
    maxCancellations?: number | null;
  } | null;
};

export type GetMyRemainingLessonsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetMyRemainingLessonsQuery = {
  getMyRemainingLessons: {
    remainingLessons: number;
    totalAvailableLessons: number;
    planEndDate?: string | null;
  };
};

export type GetUserRemainingLessonByWeekQueryVariables = Exact<{
  dateUtc: Scalars["String"]["input"];
  clientTimezone: Scalars["String"]["input"];
}>;

export type GetUserRemainingLessonByWeekQuery = {
  getUserRemainingLessonByWeek: {
    remainingLessonCount: number;
    totalLessonCount: number;
    hasUnlimitedLessonsPerWeek: boolean;
  };
};

export type UserActivePlansStatusQueryVariables = Exact<{
  [key: string]: never;
}>;

export type UserActivePlansStatusQuery = {
  userActivePlansStatus: {
    hasActive1on1Plan: boolean;
    hasActiveGroupPlan: boolean;
  };
};

export type DeleteMeMutationVariables = Exact<{ [key: string]: never }>;

export type DeleteMeMutation = { deleteMe: boolean };

export type UserFragmentFragment = {
  id: string;
  email: string;
  givenName: string;
  familyName: string;
  speakingLevel: SpeakingLevel;
  hideBookProgressCheckSection: boolean;
  hideBookSpeakingClassSection: boolean;
  createdAt: string;
  userGroup: { name: string; id: string; slug: string };
} & { " $fragmentName"?: "UserFragmentFragment" };

export type GetUserGroupAvailableDaysQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetUserGroupAvailableDaysQuery = {
  getUserGroupAvailableDays: { availableWeekDays: Array<WeekDayEnum> };
};

export type MeQueryVariables = Exact<{ [key: string]: never }>;

export type MeQuery = {
  me?: {
    " $fragmentRefs"?: { UserFragmentFragment: UserFragmentFragment };
  } | null;
};

export type SendResetPasswordEmailMutationVariables = Exact<{
  [key: string]: never;
}>;

export type SendResetPasswordEmailMutation = {
  sendResetPasswordEmail: boolean;
};

export type UpdateLastLoginMutationVariables = Exact<{ [key: string]: never }>;

export type UpdateLastLoginMutation = { updateLastLogin: boolean };

export type UpdateMeMutationVariables = Exact<{
  givenName?: InputMaybe<Scalars["String"]["input"]>;
  familyName?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type UpdateMeMutation = {
  updateMe: {
    " $fragmentRefs"?: { UserFragmentFragment: UserFragmentFragment };
  };
};

export type GetUserClassRoomCountQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetUserClassRoomCountQuery = {
  getUserClassRoomCount: { totalClassRoomCount: number };
};

export const BookableSlotFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BookableSlotFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BookableSlot" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "slotId" } },
          { kind: "Field", name: { kind: "Name", value: "startDateUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endDateUtc" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasEnoughRemainingLessons" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "topic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "level" } },
                { kind: "Field", name: { kind: "Name", value: "pdfUrl" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "capacity" } },
          { kind: "Field", name: { kind: "Name", value: "slotLevel" } },
          { kind: "Field", name: { kind: "Name", value: "participantsCount" } },
          { kind: "Field", name: { kind: "Name", value: "slotType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "userIsAParticipant" },
          },
          { kind: "Field", name: { kind: "Name", value: "slotTimezone" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "classRoom" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "meetingUri" } },
                { kind: "Field", name: { kind: "Name", value: "canBeLeaved" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BookableSlotFragmentFragment, unknown>;
export const ClassRoomFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClassRoomFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ClassRoomWithoutParticipantDto" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "endedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "startedAtUtc" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "topic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "level" } },
                { kind: "Field", name: { kind: "Name", value: "pdfUrl" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
          { kind: "Field", name: { kind: "Name", value: "capacity" } },
          { kind: "Field", name: { kind: "Name", value: "participantsCount" } },
          { kind: "Field", name: { kind: "Name", value: "meetingUri" } },
          { kind: "Field", name: { kind: "Name", value: "canBeLeaved" } },
          { kind: "Field", name: { kind: "Name", value: "classRoomTimezone" } },
          { kind: "Field", name: { kind: "Name", value: "is1on1" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClassRoomFragmentFragment, unknown>;
export const ClassRoomV2FragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClassRoomV2" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ClassRoomV2" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "endedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "startedAtUtc" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "topic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "level" } },
                { kind: "Field", name: { kind: "Name", value: "pdfUrl" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
          { kind: "Field", name: { kind: "Name", value: "capacity" } },
          { kind: "Field", name: { kind: "Name", value: "participantsCount" } },
          { kind: "Field", name: { kind: "Name", value: "meetingUri" } },
          { kind: "Field", name: { kind: "Name", value: "canBeLeaved" } },
          { kind: "Field", name: { kind: "Name", value: "classRoomTimezone" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "teacher" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "givenName" } },
                { kind: "Field", name: { kind: "Name", value: "familyName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClassRoomV2Fragment, unknown>;
export const FrozenWeekFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FrozenWeek" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FrozenWeekDto" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startOfWeekUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endOfWeekUtc" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FrozenWeekFragment, unknown>;
export const GetFreezableWeeksResponseFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GetFreezableWeeksResponse" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "GetFreezableWeeksResponse" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "weeks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "planId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "week" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startOfWeekUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endOfWeekUtc" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "remainingWeeksToFreeze" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "planId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remainingCount" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFreezableWeeksResponseFragment, unknown>;
export const UserFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "givenName" } },
          { kind: "Field", name: { kind: "Name", value: "familyName" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBookProgressCheckSection" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBookSpeakingClassSection" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userGroup" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserFragmentFragment, unknown>;
export const GetClassRoomByIdV2Document = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getClassRoomByIdV2" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "classRoomId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getClassRoomByIdV2" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "classRoomId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "classRoomId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ClassRoomV2" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClassRoomV2" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ClassRoomV2" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "endedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "startedAtUtc" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "topic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "level" } },
                { kind: "Field", name: { kind: "Name", value: "pdfUrl" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
          { kind: "Field", name: { kind: "Name", value: "capacity" } },
          { kind: "Field", name: { kind: "Name", value: "participantsCount" } },
          { kind: "Field", name: { kind: "Name", value: "meetingUri" } },
          { kind: "Field", name: { kind: "Name", value: "canBeLeaved" } },
          { kind: "Field", name: { kind: "Name", value: "classRoomTimezone" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "teacher" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "givenName" } },
                { kind: "Field", name: { kind: "Name", value: "familyName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetClassRoomByIdV2Query,
  GetClassRoomByIdV2QueryVariables
>;
export const LeaveClassRoomReviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "leaveClassRoomReview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "classRoomId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "reviewNotes" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teacherClearanceScore" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teacherComfortableScore" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teacherInvolvementScore" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "generalLessonScore" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "topicDifficultyScore" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "topicUsefulnessScore" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "leaveClassRoomReview" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "classRoomId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "classRoomId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "reviewNotes" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "reviewNotes" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "teacherClearanceScore" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teacherClearanceScore" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "teacherComfortableScore" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teacherComfortableScore" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "teacherInvolvementScore" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teacherInvolvementScore" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "generalLessonScore" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "generalLessonScore" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "topicDifficultyScore" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "topicDifficultyScore" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "topicUsefulnessScore" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "topicUsefulnessScore" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LeaveClassRoomReviewMutation,
  LeaveClassRoomReviewMutationVariables
>;
export const LeaveClassRoomDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "leaveClassRoom" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "classRoomId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "leaveClassRoom" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "classRoomId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "classRoomId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ClassRoomFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClassRoomFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ClassRoomWithoutParticipantDto" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "endedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "startedAtUtc" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "topic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "level" } },
                { kind: "Field", name: { kind: "Name", value: "pdfUrl" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
          { kind: "Field", name: { kind: "Name", value: "capacity" } },
          { kind: "Field", name: { kind: "Name", value: "participantsCount" } },
          { kind: "Field", name: { kind: "Name", value: "meetingUri" } },
          { kind: "Field", name: { kind: "Name", value: "canBeLeaved" } },
          { kind: "Field", name: { kind: "Name", value: "classRoomTimezone" } },
          { kind: "Field", name: { kind: "Name", value: "is1on1" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LeaveClassRoomMutation,
  LeaveClassRoomMutationVariables
>;
export const GetUserClassRoomsBetweenDatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getUserClassRoomsBetweenDates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "fromDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "toDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "clientTimezone" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserClassRoomsBetweenDates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "fromDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "fromDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "toDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "toDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "clientTimezone" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "clientTimezone" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ClassRoomFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClassRoomFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ClassRoomWithoutParticipantDto" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "endedAtUtc" } },
          { kind: "Field", name: { kind: "Name", value: "startedAtUtc" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "topic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "level" } },
                { kind: "Field", name: { kind: "Name", value: "pdfUrl" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
          { kind: "Field", name: { kind: "Name", value: "capacity" } },
          { kind: "Field", name: { kind: "Name", value: "participantsCount" } },
          { kind: "Field", name: { kind: "Name", value: "meetingUri" } },
          { kind: "Field", name: { kind: "Name", value: "canBeLeaved" } },
          { kind: "Field", name: { kind: "Name", value: "classRoomTimezone" } },
          { kind: "Field", name: { kind: "Name", value: "is1on1" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserClassRoomsBetweenDatesQuery,
  GetUserClassRoomsBetweenDatesQueryVariables
>;
export const BookProgressCheckDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "bookProgressCheck" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "bookSlotInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "BookSlotInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "bookProgressCheck" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "bookSlotInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "bookSlotInput" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BookProgressCheckMutation,
  BookProgressCheckMutationVariables
>;
export const HasUnlockedProgressCheckDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "hasUnlockedProgressCheck" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "hasUnlockedProgressCheck" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "lessonCompletedToUnlockProgressCheck",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "totalLessonNeededToUnlockProgressCheck",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hasUnlockedProgressCheck" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  HasUnlockedProgressCheckQuery,
  HasUnlockedProgressCheckQueryVariables
>;
export const GetAvailabilityForProgressCheckDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getAvailabilityForProgressCheck" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "clientTimezone" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "fromDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "toDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAvailabilityForProgressCheck" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clientTimezone" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "clientTimezone" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "fromDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "fromDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "toDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "toDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "slots" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "BookableSlotFragment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "hasAtLeastOnProgressCheckBookable",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BookableSlotFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BookableSlot" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "slotId" } },
          { kind: "Field", name: { kind: "Name", value: "startDateUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endDateUtc" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasEnoughRemainingLessons" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "topic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "level" } },
                { kind: "Field", name: { kind: "Name", value: "pdfUrl" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "capacity" } },
          { kind: "Field", name: { kind: "Name", value: "slotLevel" } },
          { kind: "Field", name: { kind: "Name", value: "participantsCount" } },
          { kind: "Field", name: { kind: "Name", value: "slotType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "userIsAParticipant" },
          },
          { kind: "Field", name: { kind: "Name", value: "slotTimezone" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "classRoom" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "meetingUri" } },
                { kind: "Field", name: { kind: "Name", value: "canBeLeaved" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAvailabilityForProgressCheckQuery,
  GetAvailabilityForProgressCheckQueryVariables
>;
export const BookSpeakingClassDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "bookSpeakingClass" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "bookSlotInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "BookSlotInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "bookSpeakingClass" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "bookSlotInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "bookSlotInput" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BookSpeakingClassMutation,
  BookSpeakingClassMutationVariables
>;
export const GetAvailabilityForSpeakingClassDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getAvailabilityForSpeakingClass" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "clientTimezone" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "fromDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "toDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAvailabilityForSpeakingClass" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "clientTimezone" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "clientTimezone" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "fromDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "fromDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "toDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "toDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "slots" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "BookableSlotFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BookableSlotFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BookableSlot" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "slotId" } },
          { kind: "Field", name: { kind: "Name", value: "startDateUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endDateUtc" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasEnoughRemainingLessons" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "topic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "level" } },
                { kind: "Field", name: { kind: "Name", value: "pdfUrl" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "capacity" } },
          { kind: "Field", name: { kind: "Name", value: "slotLevel" } },
          { kind: "Field", name: { kind: "Name", value: "participantsCount" } },
          { kind: "Field", name: { kind: "Name", value: "slotType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "userIsAParticipant" },
          },
          { kind: "Field", name: { kind: "Name", value: "slotTimezone" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "classRoom" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "meetingUri" } },
                { kind: "Field", name: { kind: "Name", value: "canBeLeaved" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAvailabilityForSpeakingClassQuery,
  GetAvailabilityForSpeakingClassQueryVariables
>;
export const HasSpeakingEnabledDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "hasSpeakingEnabled" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "hasSpeakingEnabled" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  HasSpeakingEnabledQuery,
  HasSpeakingEnabledQueryVariables
>;
export const IsActiveUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "isActiveUser" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "isActiveUser" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IsActiveUserQuery, IsActiveUserQueryVariables>;
export const GetFreezableWeeksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getFreezableWeeks" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getFreezableWeeks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "GetFreezableWeeksResponse" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GetFreezableWeeksResponse" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "GetFreezableWeeksResponse" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "weeks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "planId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "week" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startOfWeekUtc" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endOfWeekUtc" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "remainingWeeksToFreeze" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "planId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remainingCount" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFreezableWeeksQuery,
  GetFreezableWeeksQueryVariables
>;
export const AddFrozenWeekDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "addFrozenWeek" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "week" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "FrozenWeekInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addFrozenWeek" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "week" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "week" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddFrozenWeekMutation,
  AddFrozenWeekMutationVariables
>;
export const IsFrozenWeekDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "isFrozenWeek" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "week" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "FrozenWeekInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "isFrozenWeek" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "week" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "week" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IsFrozenWeekQuery, IsFrozenWeekQueryVariables>;
export const GetMyFrozenWeeksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getMyFrozenWeeks" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getMyFrozenWeeks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FrozenWeek" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FrozenWeek" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FrozenWeekDto" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startOfWeekUtc" } },
          { kind: "Field", name: { kind: "Name", value: "endOfWeekUtc" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetMyFrozenWeeksQuery,
  GetMyFrozenWeeksQueryVariables
>;
export const RemoveFrozenWeekDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "removeFrozenWeek" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "week" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "FrozenWeekInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeFrozenWeek" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "week" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "week" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveFrozenWeekMutation,
  RemoveFrozenWeekMutationVariables
>;
export const GetMyRemaining1on1LessonsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getMyRemaining1on1Lessons" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getMyRemaining1on1Lessons" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remainingLessons" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalAvailableLessons" },
                },
                { kind: "Field", name: { kind: "Name", value: "planEndDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cancellationsUsed" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxCancellations" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetMyRemaining1on1LessonsQuery,
  GetMyRemaining1on1LessonsQueryVariables
>;
export const GetMyRemainingLessonsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getMyRemainingLessons" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getMyRemainingLessons" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remainingLessons" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalAvailableLessons" },
                },
                { kind: "Field", name: { kind: "Name", value: "planEndDate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetMyRemainingLessonsQuery,
  GetMyRemainingLessonsQueryVariables
>;
export const GetUserRemainingLessonByWeekDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getUserRemainingLessonByWeek" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateUtc" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "clientTimezone" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserRemainingLessonByWeek" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "dateUtc" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "dateUtc" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "clientTimezone" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "clientTimezone" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "remainingLessonCount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalLessonCount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hasUnlimitedLessonsPerWeek" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserRemainingLessonByWeekQuery,
  GetUserRemainingLessonByWeekQueryVariables
>;
export const UserActivePlansStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "userActivePlansStatus" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "userActivePlansStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hasActive1on1Plan" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hasActiveGroupPlan" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UserActivePlansStatusQuery,
  UserActivePlansStatusQueryVariables
>;
export const DeleteMeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteMe" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "deleteMe" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteMeMutation, DeleteMeMutationVariables>;
export const GetUserGroupAvailableDaysDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getUserGroupAvailableDays" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserGroupAvailableDays" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableWeekDays" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserGroupAvailableDaysQuery,
  GetUserGroupAvailableDaysQueryVariables
>;
export const MeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "me" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "me" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "givenName" } },
          { kind: "Field", name: { kind: "Name", value: "familyName" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBookProgressCheckSection" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBookSpeakingClassSection" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userGroup" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const SendResetPasswordEmailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "sendResetPasswordEmail" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendResetPasswordEmail" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendResetPasswordEmailMutation,
  SendResetPasswordEmailMutationVariables
>;
export const UpdateLastLoginDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateLastLogin" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "updateLastLogin" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateLastLoginMutation,
  UpdateLastLoginMutationVariables
>;
export const UpdateMeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateMe" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "givenName" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "familyName" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateMe" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "givenName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "givenName" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "familyName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "familyName" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "givenName" } },
          { kind: "Field", name: { kind: "Name", value: "familyName" } },
          { kind: "Field", name: { kind: "Name", value: "speakingLevel" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBookProgressCheckSection" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBookSpeakingClassSection" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userGroup" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateMeMutation, UpdateMeMutationVariables>;
export const GetUserClassRoomCountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getUserClassRoomCount" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserClassRoomCount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalClassRoomCount" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserClassRoomCountQuery,
  GetUserClassRoomCountQueryVariables
>;
